import React from "react";
import { getValue } from "@utils/lodash";

function MenuMoreSvgComponent(props: any) {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        height={
          getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
        }
        width={
          getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
        }
      >
        <defs>
          <clipPath id="clip-path3">
            <rect
              id="Rectangle_18185"
              data-name="Rectangle 18185"
              width="24"
              height="24"
              transform="translate(-16226 -7998)"
              fill="#fff"
            />
          </clipPath>
        </defs>
        <g
          id="Mask_Group_293"
          data-name="Mask Group 293"
          transform="translate(16226 7998)"
          clipPath="url(#clip-path3)"
        >
          <path
            id="read_more_FILL0_wght300_GRAD0_opsz24_1_"
            data-name="read_more_FILL0_wght300_GRAD0_opsz24 (1)"
            d="M8.368-11.593l-1.1-1.025,3.437-3.239H3.158v-1.472h7.549L7.269-20.568l1.1-1.025,5.362,5Zm5.8-.451v-1.472h8.988v1.472Zm0-7.626v-1.472h8.988v1.472Zm3.158,3.813v-1.472h5.83v1.472h-5.83Z"
            transform="translate(-16227.158 -7969.407)"
            fill={
              getValue(props, `color`, "")
                ? getValue(props, `color`, "")
                : "#5f6368"
            }
          />
        </g>
      </svg>
    </div>
  );
}

export default MenuMoreSvgComponent;
